import {
  MerchantDashboardWidgetColumnsSchema,
  MerchantDashboardWidgetSizeSchema,
  MerchantDashboardWidgetTypeSchema,
  MiniViewSourceTableSchema,
} from "@redotech/redo-views-common/merchant-dashboards";
import { baseViewWithIdSchema } from "@redotech/redo-views-common/views";
import {
  merchantDashboardIdFormat,
  merchantDashboardWidgetIdFormat,
} from "@redotech/redo-warehouse-id";
import * as z from "zod";

export const MerchantDashboardNameSchema = z.string().trim().min(1).max(100);

export const MerchantDashboardWidgetTitleSchema = z
  .string()
  .trim()
  .min(1)
  .max(100)
  .nullable();

export const MerchantDashboardSummarySchema = z.object({
  id: merchantDashboardIdFormat.schema,
  name: z.string(),
});

export const MerchantDashboardWidgetSchema = z.object({
  id: merchantDashboardWidgetIdFormat.schema,
  type: MerchantDashboardWidgetTypeSchema,
  title: z.string().nullable(),
  sourceViewId: z.string(),
  sourceTable: MiniViewSourceTableSchema,
  position: z.number(),
  size: MerchantDashboardWidgetSizeSchema,
  columns: MerchantDashboardWidgetColumnsSchema,
  sourceView: baseViewWithIdSchema.nullable(),
});
